export const AppType = {
    CSS: 'CSS',
};

export const IsInternalLoginOnly = {
    isInternalLoginOnly: 'true',
};